export default __webpack_public_path__ + "static/media/2.1ae6c640.png";